<template>
  <div class="main-container">
    <h2 class="title-expandable">{{ title }}</h2>
    <div id="content-container" :style="{ 'max-height': open ? null : height }">
      <div :id="'first-element' + title"></div>
      <slot></slot>
      <div :id="'second-element' + title"></div>
    </div>
    <div class="showMore" v-if="overflow" @click="open = !open">
      <span v-if="!open">{{ $t("home-container.seeMore") }}</span
      ><span v-else>{{ $t("home-container.reduce") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      overflow: false,
      open: false
    }
  },
  props: {
    title: { type: String, required: true },
    height: { type: String, required: true }
  },
  updated () {
    this.checkIfSeeMore()
  },
  mounted () {
    window.onresize = () => { this.checkIfSeeMore() }
    this.checkIfSeeMore()
  },
  methods: {
    checkIfSeeMore () {
      const firstElement = document.getElementById('first-element' + this.title)
      const secondElement = document.getElementById('second-element' + this.title)
      if (firstElement && secondElement) {
        this.overflow = firstElement.offsetTop !== secondElement.offsetTop
      }
    }
  }
}
</script>

<style>
.main-container {
  border-radius: 10px;
  width: 100%;
  padding: 30px 44px 55px 44px;
  background: #f9f9f9;
  margin-bottom: 35px;
}

.showMore {
  text-decoration: underline;
  float: right;
  color: #3885ee;
  cursor: pointer;
}

.title-expandable {
  color: #10367a;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  text-transform: uppercase;
  text-align: left;
}

#first-element,
#second-element {
  width: 0px;
  height: 0px;
}

#content-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow: hidden;
}
</style>
